export const WEEKLY_PLAN_REFRESH_EVENT = "weekly-plan:refresh";

export const dispatchWeeklyPlanRefresh = (brandId: string) => {
  if (typeof window === "undefined" || !brandId) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(WEEKLY_PLAN_REFRESH_EVENT, {
      detail: { brandId },
    })
  );
};
